import { render, staticRenderFns } from "./Student.vue?vue&type=template&id=5f61623f&scoped=true"
import script from "./Student.vue?vue&type=script&lang=js"
export * from "./Student.vue?vue&type=script&lang=js"
import style0 from "./Student.vue?vue&type=style&index=0&id=5f61623f&prod&scoped=true&lang=css"
import style1 from "./Student.vue?vue&type=style&index=1&id=5f61623f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f61623f",
  null
  
)

export default component.exports